import { createFileRoute } from "@tanstack/react-router";
import ProfitabilityPage from "@/components/profitability/profitability-page";

export const Route = createFileRoute("/_app/profitability/")({
	component: ProfitabilityPage,
});
